const getters = {
  selectedCount: state => state.selected.length
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js